export default __webpack_public_path__ + "static/media/apps.6808f18a.svg";